import { render, staticRenderFns } from "./taskToSignSequence.vue?vue&type=template&id=5bd2f7df&scoped=true&"
import script from "./taskToSignSequence.vue?vue&type=script&lang=js&"
export * from "./taskToSignSequence.vue?vue&type=script&lang=js&"
import style0 from "./taskToSignSequence.vue?vue&type=style&index=0&id=5bd2f7df&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd2f7df",
  null
  
)

export default component.exports